import { IComponentOptions, IController, IScope } from "angular";
import { BadgeEvents, IBadgeAwardChangedArgs } from "../../badgeEvents";
import { IBadge } from "../../models/badges";
import { BadgesModalsService } from "../../services/badgesModals";

export class UserBadgesDetailsCtrl implements IController {
  badgeAssignments: IBadge[];
  userId: string;
  private badgeEvents: BadgeEvents;

  static $inject = ["$scope", "BadgesModalsService"];

  constructor(private $scope: IScope, private badgesModalsService: BadgesModalsService) {
    this.badgeEvents = new BadgeEvents(this.$scope);
    this.badgeEvents.onBadgeAwardChanged((args) => this.onBadgeAwardChanged(args));
  }

  private onBadgeAwardChanged = ({ action, assignment, badge }: IBadgeAwardChangedArgs) => {
    if (assignment.assigneeIds.includes(this.userId)) {
      switch (action) {
        case "assigned":
          // in the employees response in the badges array, the id property is the id of the assignment,
          // not the badge, but the rest is the badge body, not the assignment's
          this.badgeAssignments = this.badgeAssignments ? [...this.badgeAssignments, { ...badge, id: assignment.id }] : [{ ...badge, id: assignment.id }];
          break;
        case "unassigned":
          this.badgeAssignments = this.badgeAssignments.filter((badgeAssignment) => badgeAssignment.id !== assignment.id);
          break;
      }
    }
  };

  openAwardDialog = (assigneeId: string): void => {
    this.badgesModalsService.openAwardDialog({ assigneeId });
  };
}

export const UserBadgesDetailsComponent: IComponentOptions = {
  bindings: {
    badgeAssignments: "<",
    userId: "@",
  },
  controller: UserBadgesDetailsCtrl,
  template: require("./user-badges-details.component.html"),
};
